import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbAccordionModule } from '@ng-bootstrap/ng-bootstrap';

import { MaterialLinkModel } from '../../business/material-link-model';

@Component({
    selector: 'ecm-mat-accordions',
    templateUrl: 'material-accordions.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [NgbAccordionModule, NgClass],
})
export class MaterialAccordionsComponent implements OnInit {
    @Input() public title?: string;
    @Input({ required: true }) public items: {
        title: string;
        description: string | string[];
        link?: MaterialLinkModel;
    }[];
    @Input() public e2e = 'e2e-mat-seo-accordions';
    @Output() public clickAccordionLink = new EventEmitter<any>();

    public ngOnInit(): void {
        // Force description to be an array
        this.items = this.items.map((item) => {
            const description = Array.isArray(item.description) ? item.description : [item.description];
            return { ...item, description };
        });
    }
}
